export default __webpack_public_path__ + "static/media/TIME-MIM.b188bcf0.svg";